<template>
  <div class="chat-messages">
    <template
      v-for="message in messages"
      :key="message.id"
    >
      <AiResponse
        v-if="isAiMessage(message)"
        :message="message"
        @rate="handleRating(message.id, $event)"
      />
      <UserMessage
        v-else
        :message="message"
      />
    </template>

    <ThinkingIndicator v-if="isSending" />
  </div>
</template>

<script setup>
import { useChat } from "../../../composables/useChat";
import UserMessage from "./UserMessage.vue";
import AiResponse from "./AiResponse.vue";
import ThinkingIndicator from "./ThinkingIndicator.vue";
const emit = defineEmits(["rateMessage"]);
const { messages, isSending } = useChat();
function handleRating(messageId, rating) {
  emit("rateMessage", messageId, rating);
}
function isAiMessage(message) {
  return message.user?.id.includes("ai_agent");
}
</script>

<style scoped>
.chat-messages{display:flex;flex-direction:column;gap:12px;min-height:-moz-max-content;min-height:max-content;padding:16px}
</style>
